<h2 mat-dialog-title>{{user_id? 'Update User' : 'Add User'}}</h2>

<form [formGroup]="UserForm" (ngSubmit)="onFormSubmit()">
    <div mat-dialog-content class="content">
        <div class="column">

            <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input [ngModel]="user_name" formControlName="user_name" matInput placeholder="Enter User Name">
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Mobile Number</mat-label>
                <input [ngModel]="user_mobile" formControlName="user_mobile" matInput
                    placeholder="Enter User Mobile Number">
            </mat-form-field>
        </div>
        <div class="column">
            <mat-form-field appearance="outline" class="flex-1">
                <mat-label>Password</mat-label>

                <input matInput [ngModel]="user_pwd" formControlName="user_pwd" [readonly]="user_id && !isResetMode"
                    [type]="(user_id && !isResetMode) ? 'password' : 'text'" placeholder="Enter Password">

                <!-- Show Reset only in Edit mode -->
                <button *ngIf="user_id && !isResetMode" mat-icon-button matSuffix type="button"
                    (click)="resetPassword()" matTooltip="Reset Password">
                    <mat-icon color="warn">edit</mat-icon>
                </button>

            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Is Active</mat-label>
                <mat-select [ngModel]="is_active" formControlName="is_active">
                    <mat-option value="1">Yes </mat-option>
                    <mat-option value="0">No </mat-option>
                </mat-select>
            </mat-form-field>
        </div>



        <div mat-dialog-actions class="action" align="end">
            <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
            <button mat-raised-button type="submit" color="primary">{{user_id? 'Update' : 'Add'}}</button>
        </div>
    </div>
</form>